import { useBoolean } from 'aa_common/front-end/hooks'

export const useAIAssistantDrawer = (onTryAgain?: () => void) => {
  const [visible, setTrue, setFalse] = useBoolean(false)
  const [showConfirmDialog, setShowConfirmDialog, setHideConfirmDialog] = useBoolean(false)

  return {
    visible,
    closeDrawer: () => {
      setFalse()
      onTryAgain?.()
    },
    openDrawer: () => {
      setTrue()
      setHideConfirmDialog()
    },
    showConfirmDialog,
    opShowConfirmDialog: () => setShowConfirmDialog(),
    onHideConfirmDialog: () => setHideConfirmDialog(),
  }
}
